import { GET_STORE_DATA, RESET_STATISTICS, REMOVE_ALARM } from '../constants';
import moment from 'moment';

const INITIAL_STATE = {
    lat: 0,
    lng: 0,
    avgDeliveryTime: 0,
    avgDrivingTime: 0,
    avgPreparationTime: 0,
    avgRating: 0,
    drivers: [],
    orders: [],
    alarms: [],
};

const storeReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_STORE_DATA:
            const { store } = action;
            if (action && store.orders && store.orders.length > 1) {
                store.orders.sort((a, b) => {
                    const aDeliveryTime = (a.requestDate ? moment(a.requestDate).unix() : a.deliveryDate ? moment(a.deliveryDate).unix() * 1000 : 0);
                    const bDeliveryTime = (b.requestDate ? moment(b.requestDate).unix() : b.deliveryDate ? moment(b.deliveryDate).unix() * 1000 : 0);
                    return aDeliveryTime - bDeliveryTime;
                });
            }

            if (store && store.scheduled && store.scheduled.length > 1) {
                store.scheduled.sort((a, b) => {
                    const aDeliveryTime = (a.requestDate ? moment(a.requestDate).unix() : a.deliveryDate ? moment(a.deliveryDate).unix() * 1000 : 0);
                    const bDeliveryTime = (b.requestDate ? moment(b.requestDate).unix() : b.deliveryDate ? moment(b.deliveryDate).unix() * 1000 : 0);
                    return aDeliveryTime - bDeliveryTime;
                });
            }
            return {
                ...store
            }
        case RESET_STATISTICS:
            return {
                avgDeliveryTime: 0,
                avgDrivingTime: 0,
                avgPreparationTime: 0,
                avgRating: 0,
                ...state,
            }
        case REMOVE_ALARM:
            return {
                ...state,
                alarm: []
            }
        default:
            return state
    }
}

export default storeReducer;